var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"30%","append-to-body":"","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"header-title",style:({
      padding: '15px 20px',
      'box-sizing': 'border-box',
      backgroundColor: _vm.isCustom
        ? _vm.customColor
        : _vm.isSimple
        ? '#FD9112'
        : '#185ED3',
    }),attrs:{"slot":"title"},slot:"title"},[_c('div',[_vm._v("新增手动标签")])]),_vm._v(" "),_c('div',{staticClass:"bj"},[_c('div',{staticStyle:{"width":"100px"}},[_vm._v("手动标签：")]),_vm._v(" "),_c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.querySearchAsync,"placeholder":"请输入内容"},on:{"select":_vm.handleSelect},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.value)),(item.class)?_c('span',{staticClass:"name"},[_vm._v(" ("+_vm._s(item.class)+")")]):_vm._e()])]}}]),model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.handleClose}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{style:({
        border: 'none',
        backgroundColor: _vm.isCustom
          ? _vm.customColor
          : _vm.isSimple
          ? '#FD9112'
          : '#185ED3',
      }),attrs:{"type":"primary"},on:{"click":_vm.changeDesc}},[_vm._v("确 定")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }